module.exports = __webpack_public_path__ + "static/media/project10.99bbc1bf.png";